export default "__VITE_ASSET__BRVnsOF5__"